import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { resources, defaultLanguage, defaultNamespace, supportedLanguages } from '../locales';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: defaultLanguage,
    defaultNS: defaultNamespace,
    ns: Object.keys(resources[defaultLanguage]),
    supportedLngs: supportedLanguages,

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    react: {
      useSuspense: false, // Disable suspense to avoid issues with SSR
    },
  });

// Update HTML lang attribute when language changes (only in browser)
if (typeof document !== 'undefined') {
  i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
  });

  // Set initial HTML lang attribute
  document.documentElement.lang = i18n.language;
}

export default i18n;
